import { useEffect, useState } from "react";
import { Construction, Clock, Wrench } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import SiteFooter from "@/components/SiteFooter";


const MaintenancePage = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchMaintenanceMessage();
  }, []);

  const fetchMaintenanceMessage = async () => {
    try {
      const { data } = await supabase
        .from("site_settings")
        .select("setting_value")
        .eq("setting_key", "maintenance_mode")
        .single();

      const settingValue = data?.setting_value as { message?: string } | null;
      if (settingValue?.message) {
        setMessage(settingValue.message);
      }
    } catch (error) {
      console.error("Error fetching maintenance message:", error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-8 text-center animate-fade-in">
        {/* Animated Icon */}
        <div className="relative inline-block">
          <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
          <Construction className="relative h-24 w-24 mx-auto text-primary animate-bounce" />
        </div>

        {/* Title */}
        <div className="space-y-3">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Site en maintenance
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-lg mx-auto">
            {message || "Nous effectuons actuellement une maintenance programmée. Le site sera de nouveau accessible sous peu."}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-4 mt-12 max-w-xl mx-auto">
          <div className="tech-border p-6 space-y-2 hover:bg-secondary/20 transition-colors">
            <Clock className="h-8 w-8 mx-auto text-primary" />
            <h3 className="font-semibold font-mono text-sm uppercase tracking-wide">Retour imminent</h3>
            <p className="text-xs text-muted-foreground">
              Nous travaillons activement pour rétablir le service
            </p>
          </div>
          
          <div className="tech-border p-6 space-y-2 hover:bg-secondary/20 transition-colors">
            <Wrench className="h-8 w-8 mx-auto text-primary" />
            <h3 className="font-semibold font-mono text-sm uppercase tracking-wide">Améliorations</h3>
            <p className="text-xs text-muted-foreground">
              Maintenance pour améliorer votre expérience
            </p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="flex items-center justify-center gap-4 mt-12">
          <div className="h-1 w-12 bg-primary animate-pulse"></div>
          <div className="h-2 w-2 rounded-full bg-primary animate-ping"></div>
          <div className="h-1 w-12 bg-primary animate-pulse"></div>
        </div>

        {/* Footer */}
        <p className="text-sm text-muted-foreground font-mono mt-8">
          PartXplorer • Maintenance en cours
        </p>
      </div>
      <SiteFooter />
    </div>
  );

};

export default MaintenancePage;
